import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() => ({
    small: {
        whiteSpace: 'nowrap',
        marginBottom: 0,
        marginRight: '8px',
    }
}))
